import { render } from "./PhotoSwipe.vue?vue&type=template&id=1a9c7e14&scoped=true&bindings={\"pswp\":\"data\",\"parent\":\"data\",\"init\":\"options\",\"push\":\"options\",\"close\":\"options\"}"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js"

import "./PhotoSwipe.vue?vue&type=style&index=0&id=1a9c7e14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a9c7e14"

export default script